/**
 * 服务能力模块布局（响应式）
 * md+ : 左侧 NavTree（固定 240px）+ 右侧 Outlet
 * md以下: 隐藏侧边栏，通过顶部 toggle 按钮打开 Drawer
 */
import { useState } from 'react';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Outlet } from 'react-router-dom';
import { NavTree } from '@/components/common/NavTree';
import { COLORS, LAYOUT } from '@/theme/tokens';

/**
 * ServiceLayout 组件
 * 左侧边栏（约 240px 宽度）+ 右侧主内容区（flex-1），md 以下改为 Drawer
 */
export function ServiceLayout(): JSX.Element {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Box sx={{ display: 'flex', gap: 0, minHeight: 'calc(100vh - 64px - 60px)' }}>
      {/* 左侧导航树 — md+ 固定显示 */}
      <Box
        sx={{
          width: `${LAYOUT.sidebarWidth}px`,
          flexShrink: 0,
          backgroundColor: COLORS.backgroundPaper,
          borderRight: `1px solid ${COLORS.border}`,
          overflowY: 'auto',
          display: { xs: 'none', md: 'block' },
        }}
      >
        <NavTree />
      </Box>

      {/* 右侧主内容区 */}
      <Box
        sx={{
          flex: 1,
          padding: { xs: 1.5, sm: 2, md: 3 },
          backgroundColor: COLORS.backgroundDefault,
          minWidth: 0,
        }}
      >
        {/* md 以下显示菜单按钮 */}
        <Box
          sx={{
            display: { xs: 'flex', md: 'none' },
            alignItems: 'center',
            gap: 1,
            mb: 2,
            pb: 1.5,
            borderBottom: `1px solid ${COLORS.border}`,
          }}
        >
          <IconButton
            onClick={() => setDrawerOpen(true)}
            sx={{ color: COLORS.primary, padding: '6px' }}
          >
            <MenuIcon />
          </IconButton>
          <Typography sx={{ fontSize: '18px', fontWeight: 700, color: COLORS.textPrimary }}>
            服务能力
          </Typography>
        </Box>

        <Outlet />
      </Box>

      {/* md 以下 Drawer 导航 */}
      <Drawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: { width: 260, pt: 2 },
        }}
      >
        <NavTree />
      </Drawer>
    </Box>
  );
}
